<img [src]="src()" [alt]="alt()" [class]="avatarClasses" />
